import { CategoryAccount } from '../models/category-account';
import { ChartFieldOption } from '../models';

export namespace CategoryAccountUtils {
  export const normalBalanceOptions = Object.freeze([
    {
      label: 'Debit',
      value: 'debit',
    },
    {
      label: 'Credit',
      value: 'credit',
    },
  ]);

  export const reportTypeOptions = Object.freeze([
    {
      label: 'Balance Sheet',
      value: 'balance',
    },
    {
      label: 'Income Statement',
      value: 'income',
    },
  ]);

  export const accountTypeOptions = Object.freeze([
    {
      label: 'Total',
      value: 'total',
    },
    {
      label: 'Group',
      value: 'group',
    },
  ]);

  export const flattenCategoryAccounts = (categoryAccounts: CategoryAccount[]): CategoryAccount[] => {
    return categoryAccounts.reduce((acc, categoryAccount) => {
      acc.push(categoryAccount);
      if (categoryAccount.children) {
        acc.push(...flattenCategoryAccounts(categoryAccount.children));
      }
      return acc;
    }, [] as CategoryAccount[]);
  };

  export const generateCategoryAccountOptions = (categoryAccounts: CategoryAccount[]): ChartFieldOption[] => {
    return flattenCategoryAccounts(categoryAccounts).map((categoryAccount) => ({
      value: categoryAccount.id,
      label: categoryAccount.name,
      format: 'money',
    }));
  };
}
